const exportedObject = {
  getZonasData: {},
  getZonasLoading: false,
  getZonasError: null,

  getProvinciasData: {},
  getProvinciasLoading: false,
  getProvinciasError: null,

  getDiagnosticosData: {},
  getDiagnosticosLoading: false,
  getDiagnosticosError: null,
};

export default exportedObject;